<template>
  <div>
    <vs-input
        v-validate="{ required: true, min:6, max:20, alpha_dash: true }"
        maxlength="21"
        data-vv-validate-on="blur"
        name="id"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        :label-placeholder="$t('ID')"
        v-model="id"
        @keyup.enter="loginJWT"
        class="w-full"/>
    <span class="text-danger text-sm">{{ errors.first('id') }}</span>

    <vs-input
        data-vv-validate-on="blur"
        maxlength="21"
        v-validate="{ required: true, max:20 }"
        type="password"
        name="password"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        :label-placeholder="$t('PASSWORD')"
        v-model="password"
        @keyup.enter="loginJWT"
        class="w-full mt-8" />
    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

    <div class="flex flex-wrap justify-between my-5">
       <router-link to="/pages/reset-password" >{{$t("ResetPassword")}}</router-link>
      <vs-button :disabled="!validateForm" @click="loginJWT">{{$t("Login")}}</vs-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: '',
      password: '',
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.id != '' && this.password != '';
    },
  },
  beforeCreate(){
  },
  methods: {
    loginJWT() {
      // Loading
      this.$vs.loading()

      const payload = {
        userDetails: {
          id: this.id,
          password: this.password
        }
      }

      this.$store.dispatch('auth/login', payload)
        .then(() => { 
          this.$vs.loading.close()
          let role = JSON.parse(sessionStorage.getItem("userInfo")).userRole
          this.$acl.change(role)
          })
        .catch((error) => {
          this.$vs.loading.close()
          this.catchErrorMessage(error.message)
        })
    },
    catchErrorMessage(errorMessage){
      if(errorMessage === 'INVALID_USER'){
        this.errorAlert(this.$t("ERROR"), this.$t('INVALID_USER'))
      }else if(errorMessage === 'LOCKED' || errorMessage === 'BLOCKED' || errorMessage === 'DORMANT'){
        this.errorAlert(this.$t("ERROR"), this.$t('ACCOUNT_MESSAGE_'+errorMessage))
      }else{
        this.errorAlert(this.$t("ERROR"), errorMessage)
      }
    }
  }
}

</script>

